import { Controller } from "stimulus"
import currency from '../helpers/currency'

export default class extends Controller {
  static targets = ["amount", "percentageButton", "customPercentage"]

  connect() {
    // Store the original value when controller connects
    const currentValue = this.amountTarget.value
    this.amountTarget.dataset.percentageButtonsOriginalValue = currentValue
  }

  applyPercentage(event) {
    event.preventDefault()
    
    const percentage = parseFloat(event.currentTarget.dataset.percentage)
    const originalValue = currency(this.amountTarget.dataset.percentageButtonsOriginalValue || this.amountTarget.value)
    
    if (!isNaN(percentage) && !isNaN(originalValue)) {
      const multiplier = percentage / 100.0
      const result = originalValue.multiply(multiplier)
      this.amountTarget.value = result
      
      // Update button states
      this.updateButtonStates(percentage)
      
      // Clear custom percentage field
      if (this.hasCustomPercentageTarget) {
        this.customPercentageTarget.value = ""
      }
      
      // Trigger any additional actions (like refreshing totals)
      this.triggerChange()
    }
  }

  applyCustomPercentage(event) {
    const customPercentage = parseFloat(event.currentTarget.value)
    
    if (!isNaN(customPercentage) && customPercentage > 0) {
      const originalValue = currency(this.amountTarget.dataset.percentageButtonsOriginalValue || this.amountTarget.value)
      
      if (!isNaN(originalValue)) {
        const multiplier = customPercentage / 100.0
        const result = originalValue.multiply(multiplier)
        this.amountTarget.value = result
        
        // Reset all button states since we're using a custom value
        this.resetButtonStates()
        
        // Trigger any additional actions
        this.triggerChange()
      }
    }
  }

  updateButtonStates(activePercentage) {
    this.percentageButtonTargets.forEach(button => {
      const buttonPercentage = parseFloat(button.dataset.percentage)
      if (buttonPercentage === activePercentage) {
        button.classList.remove("btn-outline-secondary")
        button.classList.add("btn-primary")
      } else {
        button.classList.remove("btn-primary")
        button.classList.add("btn-outline-secondary")
      }
    })
  }

  resetButtonStates() {
    this.percentageButtonTargets.forEach(button => {
      button.classList.remove("btn-primary")
      button.classList.add("btn-outline-secondary")
    })
  }

  triggerChange() {
    // Trigger a change event on the amount field
    const event = new Event('input', { bubbles: true })
    this.amountTarget.dispatchEvent(event)
    
    // Also trigger any custom action that was on the original field
    const customAction = this.amountTarget.dataset.action
    if (customAction && customAction.includes('#')) {
      // Parse and trigger the custom action
      const [controllerAction] = customAction.split(' ').filter(a => a.includes('#'))
      if (controllerAction) {
        const [controllerName, actionName] = controllerAction.split('#')
        const changeEvent = new Event('change', { bubbles: true })
        this.amountTarget.dispatchEvent(changeEvent)
      }
    }
  }
}